'use client';

import { Form } from '@/components/form';

import { ModalButtonsWrapper } from './buttons';

import type { FormModalProps } from './modal.types';
import type { FieldValues } from 'react-hook-form';

export const FormModalContent = <T extends FieldValues>({
  children,
  buttonComponent,
  ...props
}: FormModalProps<T>) => (
  <>
    <Form<T>
      {...props}
      className="flex grow flex-col gap-e overflow-y-auto p-e md:gap-d lg:p-d "
    >
      {children}
    </Form>
    <ModalButtonsWrapper>{buttonComponent}</ModalButtonsWrapper>
  </>
);
